import EarlyBirdCandidate from './EarlyBirdCandidate';

export default EarlyBirdCandidate;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCandidate/index.js